import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import session from "./session";
import motion from "./motion";

/* The whole stylesheet: self-hosted Nunito and the page classes.
   No Bootstrap, no Aeroland scss, no Font Awesome, no animate.css, no swiper. */
import './assets/site/fonts.css';
import './assets/site/landing.css';

createApp(App).use(router).use(i18n).use(session).use(motion).mount("#app");
